export default __webpack_public_path__ + "elevation-500-79276ae0207d75adcf7f4c718f567be2.webp";